declare namespace $ {

	type __shm_showcase_demo_period_1 = $mol_type_enforce<
		Parameters< $shm_showcase_demo_period['period_str'] >[0]
		,
		Parameters< ReturnType< $shm_showcase_demo_period['Input'] >['period_str'] >[0]
	>
	type $mol_text__text_shm_showcase_demo_period_2 = $mol_type_enforce<
		ReturnType< $shm_showcase_demo_period['period_str'] >
		,
		ReturnType< $mol_text['text'] >
	>
	export class $shm_showcase_demo_period extends $mol_list {
		period_str( next?: ReturnType< ReturnType< $shm_showcase_demo_period['Input'] >['period_str'] > ): ReturnType< ReturnType< $shm_showcase_demo_period['Input'] >['period_str'] >
		Input( ): $shm_period
		Selected( ): $mol_text
		rows( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=period.view.tree.d.ts.map